// Import Libraries
import React, { Component } from 'react';
// Import JS Modules
import { builderDispatch } from '../../../_utils/ui';
import { UpdatePhotoEvents } from '../../common/events/event-declarations';
// Import JSX Modules
import PandaViewSimplePreviews from '../../common/panda-view-simple-previews';
import canOpenAdvancedEditor from '../../common/can-open-advanced-editor';

class ListViewItemPreviewAndControls extends Component {
  static isEditEnabled(photo) {
    const { quantity, uploaded, fromBasket } = photo;

    return (
      !!quantity && (!!fromBasket || !!uploaded) && canOpenAdvancedEditor(photo)
    );
  }

  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleRemoveByRootId = this.handleRemoveByRootId.bind(this);
  }

  handleEdit() {
    const {
      photo: { client_uuid: clientUuid },
      isLastPhoto,
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.ADVANCED_EDIT,
      clientUuid,
      isLastPhoto,
    });
  }

  handleRemove() {
    const {
      photo: { client_uuid: clientUuid },
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.REMOVE,
      clientUuid,
    });
  }

  handleRemoveByRootId() {
    const {
      photo: { client_uuid: clientUuid },
    } = this.props;

    builderDispatch.dispatch({
      type: UpdatePhotoEvents.SHOW_REMOVE_CONFIRMATION,
      clientUuid,
      useRoot: true,
    });
  }

  render() {
    const {
      photo,
      displayRootImageOnly,
      isLastPhoto,
      showSize,
      showQuantity,
      showPreviewWarning,
      recommendedPrintSizeTextForPreview,
      recommendedPrintSize,
      disabled,
    } = this.props;

    const {
      size: { title: size, area },
      filename,
    } = photo;

    const handleEdit = displayRootImageOnly ? undefined : this.handleEdit;
    const handleRemove =
      displayRootImageOnly || isLastPhoto
        ? this.handleRemoveByRootId
        : this.handleRemove;

    return (
      <div className="d-inline-block list-item__preview">
        <PandaViewSimplePreviews
          {...photo}
          isWallet={size === 'Wallet'}
          size_area={area}
          recommendedPrintSize={recommendedPrintSize}
          showSize={showSize}
          showQuantity={showQuantity}
          showPreviewWarning={showPreviewWarning}
          recommendedPrintSizeTextForPreview={
            recommendedPrintSizeTextForPreview
          }
          previewMaxPx={180}
          onClick={handleEdit}
        />

        <div
          role="toolbar"
          className="list-item__controls d-flex justify-content-between align-items-center">
          <button
            type="button"
            className="btn btn-link btn-underline edit-photo"
            disabled={!this.constructor.isEditEnabled(photo) || disabled}
            aria-label={`Edit ${filename} ${size}`}
            title={`Edit ${filename} ${size}`}
            role="link"
            onClick={handleEdit}>
            Edit
          </button>
          <button
            type="button"
            className="btn btn-link remove-photo"
            disabled={disabled}
            aria-label={`Delete ${filename} ${size}`}
            title={`Delete ${filename} ${size}`}
            onClick={handleRemove}>
            <i className="far fa-trash-alt" />
          </button>
        </div>
      </div>
    );
  }
}

export default ListViewItemPreviewAndControls;
